import axios from 'axios';
import { API } from '@/App';
import { toast } from 'sonner';

export async function smartShuffle(trackIds) {
  if (!trackIds || trackIds.length < 2) {
    toast.error('Need at least 2 tracks to shuffle');
    return null;
  }
  
  try {
    const response = await axios.post(`${API}/tracks/smart-shuffle`, {
      track_ids: trackIds
    });
    toast.success('Shuffled by key & energy');
    return response.data.tracks;
  } catch (error) {
    toast.error('Shuffle failed');
    return null;
  }
}
